export default __webpack_public_path__ + "static/media/shanice.619cd91c.JPG";